/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { createContext } from 'react';

import __noop from '@atlaskit/ds-lib/noop';

import { defaultFeatureFlags } from './default-feature-flags';
import type { FeatureFlagList } from './types';

/**
 * Example-level flags are now controlled via Example props (featureFlagDefaults, featureFlagSwitchers).
 * Use those so each example declares what it needs; no path-based config.
 */

export type FeatureFlagContextProps = {
	features: FeatureFlagList;
	setFeatureFlag: (featureFlagName: string, value: boolean) => void;
};

export const FeatureFlagContext: React.Context<FeatureFlagContextProps> =
	createContext<FeatureFlagContextProps>({
		features: defaultFeatureFlags,
		setFeatureFlag: __noop,
	});
